import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Grid,
  GridItem,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  StatUpArrow,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import CustomTable from "../../components/UI/Table";
import {
  ChangeClientGlobalSettingAPI,
  ChangeClientLimitAPI,
  ChangeClientPasswordAPI,
  ChangeClientStatusAPI,
  ClientWithdrawAndDepositAPI,
  getClientAPI,
  getGlobalSettingsAPI,
  searchChildrenAPI,
} from "../../service/UserService";
import { Encrypt } from "../../utils/constants";
import DepositAndWithdraw from "./Forms/DepositAndWithdraw";
import ExposureAndCreditLimit from "./Forms/ExposureAndCreditLimit";
import GlobalSettings from "./Forms/GlobalSettings";
import Password from "./Forms/Password";
import Status from "./Forms/Status";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import "./List.css";
export default function ListClient() {
  const { id } = useParams();
  const [clientData, setClientData] = useState([]);
  const [globalSetting, setGlobalSetting] = useState({});
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modalAction, setModalAction] = useState("");
  const [payload, setPayload] = useState({});
  const [isBalanceOpen, setIsBalanceOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [size, setSize] = useState(20);
  const [searchParams] = useSearchParams();
  const filterParam = searchParams.get("filter");
  const [userTypeFilter, setUserTypeFilter] = useState("ALL");
  const [expandedClients, setExpandedClients] = useState(new Set());

  const toggleClient = (uid) => {
    setExpandedClients((prev) => {
      const next = new Set(prev);
      if (next.has(uid)) next.delete(uid);
      else next.add(uid);
      return next;
    });
  };

  useEffect(() => {
    const validTypes = ["SUPER_ADMIN", "ADMIN", "SUPER", "MASTER", "AGENT", "CLIENT"];
    setUserTypeFilter(filterParam && validTypes.includes(filterParam) ? filterParam : "ALL");
  }, [filterParam]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const getClient = async () => {
    const { response } = await getClientAPI(search, currentPage, size, id);
    let response_ = response;
    if (response_) {
      response_.childrenUserResponseDTOS =
        response_.childrenUserResponseDTOSPage.content.sort(
          (a, b) => a.uid - b.uid
        );
      setCurrentPage(response_.childrenUserResponseDTOSPage.number);
      setTotalPages(response_.childrenUserResponseDTOSPage.totalPages);
      setTotalElements(response_.childrenUserResponseDTOSPage.totalElements);
      setSize(response_.childrenUserResponseDTOSPage.size);
    }
    setClientData(response_);
  };

  const nextPage = () => {
    if (currentPage < totalPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };
  const prevPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };
  const getGlobalSetting = async () => {
    try {
      const { response } = await getGlobalSettingsAPI();
      setGlobalSetting(response);
    } catch (error) {
      // dispatch({
      //   type: "accountData/logOut",
      //   payload: {},
      // });
      // window.localStorage.clear();
      // window.location.href = "/";
      console.error('getGlobalSetting error:', error);
    }
  };
  useEffect(() => {
    getClient();
    getGlobalSetting();
  }, [currentPage, totalPages, totalElements, id]);
  const internalSearch = (e) => {
    if (e.target.value.length == 0) {
      getClient();
    }
    if (e.target.value.length > 3) {
      let response_ = clientData.childrenUserResponseDTOS.filter((item) => {
        return (
          item.uid == e.target.value ||
          item?.username
            ?.toLowerCase()
            .includes(e?.target?.value.toLowerCase()) ||
          item?.name?.toLowerCase().includes(e?.target?.value.toLowerCase())
        );
      });
      setClientData({ ...clientData, childrenUserResponseDTOS: response_ });
    }
  };
  const handleModalOpen = (id, user) => {
    clearSearch();
    let payload_ = { ...payload, id, user: { ...user, ...globalSetting } };
    setPayload(payload_);
    setModalAction(id);
    onOpen();
  };
  const getModalBody = () => {
    if (modalAction === "Deposit") {
      return (
        <DepositAndWithdraw
          payload={payload}
          setPayload={setPayload}
          myAvailableBalance={clientData?.myAvailableBalance}
          userName={id}
        />
      );
    } else if (modalAction == "Withdraw") {
      return (
        <DepositAndWithdraw
          payload={payload}
          setPayload={setPayload}
          isWithdraw={true}
          myAvailableBalance={clientData?.myAvailableBalance}
          userName={id}
        />
      );
    } else if (modalAction == "Exposure Limit") {
      return (
        <ExposureAndCreditLimit
          clientData={clientData.childrenUserResponseDTOS}
          payload={payload}
          setPayload={setPayload}
          userName={id}
        />
      );
    } else if (modalAction == "Credit Limit") {
      return (
        <ExposureAndCreditLimit
          payload={payload}
          setPayload={setPayload}
          clientData={clientData.childrenUserResponseDTOS}
          isCreditLimit={true}
          userName={id}
        />
      );
    } else if (modalAction == "Change Password") {
      return <Password payload={payload} setPayload={setPayload} />;
    } else if (modalAction == "Status") {
      return <Status payload={payload} setPayload={setPayload} />;
    } else if (modalAction == "Global Setting") {
      return <GlobalSettings payload={payload} setPayload={setPayload} />;
    }
  };
  const handleModalSubmit = async () => {
    if (
      (payload.transactionPassword == "" ||
        !payload.transactionPassword ||
        payload.transactionPassword.length < 6) &&
      modalAction != "Global Setting"
    ) {
      toast.error("Transaction Password is not valid");
      return;
    }
    let isRequestFailed = false;
    let failMessage = null;
    if (modalAction === "Status") {
      const { response, code, status } = await ChangeClientStatusAPI(
        payload.user.uid,
        payload.isActive,
        payload.isBetActive,
        payload.transactionPassword
      );
      if (code == 200) {
        toast.success(status);
        setPayload({});
        onClose();
        window.location.reload();
      } else {
        isRequestFailed = true;
        if (response) failMessage = response;
      }
    }
    if (modalAction == "Exposure Limit" || modalAction == "Credit Limit") {
      const { response, code, status } = await ChangeClientLimitAPI(
        {
          newLimit: payload.newLimit,
          transactionPassword: payload.transactionPassword,
          oldLimit: payload.oldLimit,
          limitType:
            modalAction == "Exposure Limit"
              ? "EXPOSURE_LIMIT"
              : "CREDIT_REFERENCE",
        },
        payload.user.uid
      );
      if (code == 200) {
        toast.success(status);
        setPayload({});
        onClose();
      } else {
        isRequestFailed = true;
        if (response) failMessage = response;
      }
    }
    if (modalAction == "Change Password") {
      if (payload.newPassword !== payload.confirmPassword)
        return toast.error("Password and Confirm Password must be same");
      if (
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/.test(
          payload.newPassword
        )
      )
        return toast.error(
          "Password must be at least 8 characters long and contains 1 alphabet, 1 number and one caps and one small letter"
        );
      const { response, code, status } = await ChangeClientPasswordAPI(
        {
          newPassword: Encrypt(payload.newPassword),
          transactionPassword: payload.transactionPassword,
          resetRequired: true,
        },
        payload.user.uid
      );
      if (code == 200) {
        toast.success(status);
        setPayload({});
        onClose();
      } else {
        isRequestFailed = true;
        if (response) failMessage = response;
      }
    }
    if (modalAction == "Global Setting") {
      if (
        payload.user.transactionPassword == "" ||
        !payload.user.transactionPassword ||
        payload.user.transactionPassword.length < 6
      ) {
        toast.error("Transaction Password is not valid");
        return;
      }
      let payload_ = payload;
      delete payload_.user.id;
      const { response, code, status } = await ChangeClientGlobalSettingAPI(
        payload_.user,
        payload.user.uid
      );
      if (code == 200) {
        toast.success(status);
        setPayload({});
        onClose();
      } else {
        isRequestFailed = true;
        if (response) failMessage = response;
      }
    }
    if (modalAction == "Deposit" || modalAction == "Withdraw") {
      const { response, code, status } = await ClientWithdrawAndDepositAPI(
        payload.user.uid,
        {
          balance: payload.amount,
          transactionPassword: payload.transactionPassword,
          remarks: payload.remarks,
          transactionType: modalAction == "Deposit" ? "DEPOSIT" : "WITHDRAW",
        }
      );
      if (code == 200) {
        toast.success(status);
        setPayload({});
        onClose();
      } else {
        isRequestFailed = true;
        if (response) failMessage = response;
      }
    }
    if (isRequestFailed && failMessage.message) {
      toast.error(
        `Something went wrong while processing ${modalAction} request . Please check your inputs and try again`
      );
    } else if (isRequestFailed) {
      toast.error(failMessage);
    }
    await getClient();
  };
  const handleSearch = async (e) => {
    setSearch(e.target.value);
    let searchText = e.target.value;
    e.preventDefault();
    if (searchText == "" || searchText.length < 3) {
      getClient();
      return;
    }
    const { response, code, status } = await searchChildrenAPI(searchText);
    if (code == 200) {
      setClientData(response);
    } else {
      getClient();
    }
  };

  const clearSearch = () => {
    setSearch("");
    getClient();
  };

  return (
    <div className="main">
      <div className="container-fluid">
        <div className="row">
          <div className="master-balance">
            <div
              onClick={() => setIsBalanceOpen(!isBalanceOpen)}
              className="text-center"
            >
              <span
                className="far fa-arrow-alt-circle-down"
                id="user-account_summary"
                style={{ display: isBalanceOpen ? "none" : "inline" }}
              />
              <span
                className="far fa-arrow-alt-circle-up"
                style={{ display: isBalanceOpen ? "inline" : "none" }}
              />
            </div>
            <div
              className="master-balance-detail m-t-20"
              id="master-balance-detail"
              style={{
                position: "relative",
                display: isBalanceOpen ? "block" : "none",
              }}
            >
              <div className="loader-ac_balance" style={{ display: "none" }}>
                <img src="/admin/assets/common/loading.gif" width="40px" />
              </div>
              <ul className="row">
                <li className="col-md-4">
                  <label className="col-md-8 text-left">
                    Upper Level Credit Referance:
                  </label>
                  <span
                    className="text-right col-md-4"
                    id="ac_summary-credit_reference"
                  >
                    {clientData?.upperCreditReference?.toFixed(2)}
                  </span>
                </li>
                <li className="col-md-4">
                  <label className="col-md-8 text-left">
                    Down level Occupy Balance:
                  </label>
                  <span
                    className="text-right col-md-4"
                    id="ac_summary-down_level_balances"
                  >
                    {clientData?.totalBalance?.toFixed(2)}
                  </span>
                </li>
                <li className="col-md-4">
                  <label className="col-md-8 text-left">
                    Down Level Credit Referance:
                  </label>
                  <span
                    className="text-right col-md-4"
                    id="ac_summary-down_level_credit_reference"
                  >
                    {clientData?.downLevelCreditReference?.toFixed(2)}
                  </span>
                </li>
                <li className="col-md-4">
                  <label className="col-md-8 text-left">
                    Total Master Balance
                  </label>
                  <span
                    className="text-right col-md-4"
                    id="ac_summary-master_balance"
                  >
                    {clientData?.totalBalance?.toFixed(2)}
                  </span>
                </li>
                <li className="col-md-4">
                  <label className="col-md-8 text-left">Upper Level:</label>
                  <span className="text-right col-md-4" id="ac_summary-up_pl">
                    0
                  </span>
                </li>
                <li className="col-md-4">
                  <label className="col-md-8 text-left">
                    Down Level Profit/Loss :
                  </label>
                  <span className="text-right col-md-4" id="ac_summary-down_pl">
                    {clientData?.downLevelPL}
                  </span>
                </li>
                <li className="col-md-4">
                  <label className="col-md-8 text-left">
                    Available Balance:
                  </label>
                  <span
                    className="text-right col-md-4"
                    id="ac_summary-available_balance"
                  >
                    {clientData?.myAvailableBalance?.toFixed(2)}
                  </span>
                </li>
                <li className="col-md-4">
                  <label className="col-md-8 text-left">
                    Available Balance With Profit/Loss:
                  </label>
                  <span
                    className="text-right col-md-4"
                    id="ac_summary-available_balance_with_pl"
                  >
                    0
                  </span>
                </li>
                <li className="col-md-4">
                  <label className="col-md-8 text-left">My Profit/Loss:</label>
                  <span className="text-right col-md-4" id="ac_summary-my_pl">
                    0
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>{modalAction}</ModalHeader>
            <ModalCloseButton />
            <ModalBody>{getModalBody()}</ModalBody>
            <ModalFooter>
              <Button size="sm" colorScheme="blue" mr={3} onClick={onClose}>
                Back
              </Button>
              <Button onClick={handleModalSubmit} size="sm" variant="ghost">
                Submit
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <div className="row">
          <div className="col-md-12 main-container">
            <div className="listing-grid">
              <div className="detail-row">
                <h2 className="d-inline-block m-b-10">Account List</h2>
                <div className="account-list-actions m-b-10">
                  <select
                    className="user-type-filter"
                    value={userTypeFilter}
                    onChange={(e) => setUserTypeFilter(e.target.value)}
                    aria-label="Filter by user type"
                  >
                    <option value="ALL">All Types</option>
                    <option value="SUPER_ADMIN">Super Admin</option>
                    <option value="ADMIN">Admin</option>
                    <option value="SUPER">Super</option>
                    <option value="MASTER">Master</option>
                    <option value="AGENT">Agent</option>
                    <option value="CLIENT">Client</option>
                  </select>
                  <a
                    href="/admin/manage-client/add"
                    className="btn btn-diamond"
                    style={{ background: "linear-gradient(to bottom, #f0c454, #d4a017)", color: "#1a1a2e", fontWeight: "600", border: "none" }}
                  >
                    Add Account
                  </a>
                </div>
              </div>
              <div
                id="clientListTable_wrapper"
                className="dataTables_wrapper no-footer"
              >
                <div className="dt-buttons">
                  {" "}
                  <button
                    className="dt-button buttons-pdf buttons-html5"
                    tabIndex={0}
                    aria-controls="clientListTable"
                    type="button"
                  >
                    <span>PDF</span>
                  </button>{" "}
                  <button
                    className="dt-button buttons-excel buttons-html5"
                    tabIndex={0}
                    aria-controls="clientListTable"
                    type="button"
                  >
                    <span>Excel</span>
                  </button>{" "}
                </div>
                <div
                  id="clientListTable_filter"
                  className="dataTables_filter"
                >
                  <label>
                    Search:
                    <input
                      type="search"
                      className="form-control"
                      placeholder="Search"
                      aria-controls="clientListTable"
                      value={search}
                      onChange={handleSearch}
                    />
                    {search && (
                      <button
                        className="clear-search"
                        onClick={clearSearch}
                        style={{ paddingLeft: "5px" }}
                      >
                        <i className="fas fa-times"></i>
                      </button>
                    )}
                  </label>
                </div>
              </div>
              <div className="table-responsive">
                <div className="dataTables_wrapper no-footer">
                  <table
                    id="clientListTable"
                    className="table table-striped  table-bordered  no-footer dataTable"
                    style={{ width: "100%" }}
                    role="grid"
                    aria-describedby="clientListTable_info"
                  >
                    <thead>
                      <tr role="row" style={{ backgroundColor: "#C9C9C9" }}>
                        <th
                          className="sorting_disabled"
                          style={{ width: "40px" }}
                        >
                          #
                        </th>
                        <th
                          className="sorting_asc sorting_disabled"
                          tabIndex={0}
                          aria-controls="clientListTable"
                          rowSpan={1}
                          colSpan={1}
                          aria-sort="ascending"
                          aria-label="User Name: activate to sort column descending"
                          style={{ width: "88px" }}
                        >
                          User Name
                        </th>
                        <th
                          className="sorting_disabled"
                          tabIndex={0}
                          aria-controls="clientListTable"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Credit Reference: activate to sort column ascending"
                          style={{ width: "132px" }}
                        >
                          Credit Reference
                        </th>
                        <th
                          className="sorting_disabled"
                          tabIndex={0}
                          aria-controls="clientListTable"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Balance: activate to sort column ascending"
                          style={{ width: "52px" }}
                        >
                          Balance
                        </th>
                        <th
                          className="sorting_disabled"
                          tabIndex={0}
                          aria-controls="clientListTable"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Client (P/L): activate to sort column ascending"
                          style={{ width: "86px" }}
                        >
                          Client (P/L)
                        </th>
                        <th
                          className="sorting_disabled"
                          tabIndex={0}
                          aria-controls="clientListTable"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Exposure: activate to sort column ascending"
                          style={{ width: "64px" }}
                        >
                          Exposure
                        </th>
                        <th
                          className="sorting_disabled"
                          tabIndex={0}
                          aria-controls="clientListTable"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Available Balance: activate to sort column ascending"
                          style={{ width: "142px" }}
                        >
                          Available Balance
                        </th>
                        <th
                          className="noExport sorting_disabled"
                          tabIndex={0}
                          aria-controls="clientListTable"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="U St: activate to sort column ascending"
                          style={{ width: "16px" }}
                        >
                          U St
                        </th>
                        <th
                          className="noExport sorting_disabled"
                          tabIndex={0}
                          aria-controls="clientListTable"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="B St: activate to sort column ascending"
                          style={{ width: "16px" }}
                        >
                          B St
                        </th>
                        <th
                          style={{
                            minWidth: "60px",
                            maxWidth: "60px",
                            width: "29px",
                          }}
                          className="sorting_disabled"
                          tabIndex={0}
                          aria-controls="clientListTable"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Exposure Limit: activate to sort column ascending"
                        >
                          Exposure Limit
                        </th>
                        <th
                          className="sorting_disabled"
                          tabIndex={0}
                          aria-controls="clientListTable"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Default %: activate to sort column ascending"
                          style={{ width: "66px" }}
                        >
                          Default %
                        </th>
                        <th
                          className="sorting_disabled"
                          tabIndex={0}
                          aria-controls="clientListTable"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Account Type: activate to sort column ascending"
                          style={{ width: "104px" }}
                        >
                          Account Type
                        </th>
                        <th
                          className="noExport sorting_disabled"
                          style={{
                            minWidth: "150px",
                            maxWidth: "150px",
                            width: "257px",
                          }}
                          tabIndex={0}
                          aria-controls="clientListTable"
                          rowSpan={1}
                          colSpan={1}
                          aria-label="Actions: activate to sort column ascending"
                        >
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody id="manage_user_tbody">
                      {clientData?.childrenUserResponseDTOS
                        ?.filter((client) => userTypeFilter === "ALL" || client.userType === userTypeFilter)
                        .map((client, index) => {
                          const isExpanded = expandedClients.has(client.uid);
                          return (
                        <tr
                          role="row"
                          className={`even${isExpanded ? " client-expanded" : ""}`}
                          key={client.uid}
                        >
                          <td data-label="#" className="mobile-sr-no">
                            {index + 1}
                          </td>
                          <td data-label="User Name" className="mobile-username-row">
                            <a
                              onClick={() =>
                                client.userType != "CLIENT" &&
                                window.open(
                                  `/admin/manage-client/list/${client.username}`,
                                  "_blank"
                                )
                              }
                              className="btn label label-default"
                              title={client.username}
                            >
                              {client.username}
                            </a>
                            <button
                              className="mobile-card-chevron"
                              onClick={() => toggleClient(client.uid)}
                              type="button"
                              aria-label={isExpanded ? "Collapse details" : "Expand details"}
                            >
                              <i className={`fas fa-chevron-${isExpanded ? "up" : "down"}`} />
                            </button>
                          </td>
                          <td className="client-mobile-summary" data-label="Balance">
                            {client?.balance?.toFixed(2)}
                          </td>
                          <td data-label="Credit Ref" className="amount-field client-mobile-detail">
                            {client.creditReference}
                          </td>
                          <td data-label="Balance" className="amount-field client-mobile-detail">
                            {client?.balance?.toFixed(2)}
                          </td>
                          <td data-label="Client P/L" className="amount-field client-mobile-detail">
                            {client?.ownPl?.toFixed(2)}
                          </td>
                          <td data-label="Exposure" className="amount-field client-mobile-detail">{client.liability}</td>
                          <td data-label="Avail. Balance" className="amount-field client-mobile-detail">
                            {client?.balance?.toFixed(2)}
                          </td>
                          <td data-label="U St" className="client-mobile-detail">
                            <label className="form-check-label">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                disabled
                                defaultChecked={
                                  client.isActive ? "checkmark" : "unchecked"
                                }
                              />
                              <span
                                style={{
                                  backgroundColor: client.isActive
                                    ? ""
                                    : "white",
                                }}
                                className="checkmark"
                              />
                            </label>
                          </td>
                          <td data-label="B St" className="client-mobile-detail">
                            <label className="form-check-label">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                disabled
                                defaultChecked={
                                  client.isBetLocked ? "unchecked" : "checkmark"
                                }
                              />
                              <span
                                style={{
                                  backgroundColor: client.isBetLocked
                                    ? "white"
                                    : "",
                                }}
                                className="checkmark"
                              />
                            </label>
                          </td>
                          <td data-label="Exp. Limit" className="amount-field client-mobile-detail">
                            {client.exposureLimit}
                          </td>
                          <td data-label="Default %" className="amount-field client-mobile-detail">
                            {client.partnershipInCricket}
                          </td>
                          <td data-label="Account Type" className="client-mobile-detail">
                            <span className="account-type-badge">{client.userType}</span>
                          </td>
                          <td data-label="Actions" className="actions client-mobile-detail">
                            <div className="action-buttons">
                              <button
                                type="button"
                                title="Deposit"
                                className="btn-custom-button btn_deposit_modal"
                                onClick={() => handleModalOpen("Deposit", client)}
                              >
                                D
                              </button>
                              <button
                                type="button"
                                title="Withdraw"
                                className="btn-custom-button btn_withdrawal_modal"
                                onClick={() =>
                                  handleModalOpen("Withdraw", client)
                                }
                              >
                                W
                              </button>
                              {!id && (
                                <>
                                  <button
                                    type="button"
                                    title="Exposure Limit"
                                    className="btn-custom-button btn_exposure_limit"
                                    onClick={() =>
                                      handleModalOpen("Exposure Limit", client)
                                    }
                                  >
                                    L
                                  </button>
                                  <button
                                    type="button"
                                    title="Credit Reference"
                                    className="btn-custom-button btn_credit_reference"
                                    onClick={() =>
                                      handleModalOpen("Credit Limit", client)
                                    }
                                  >
                                    C
                                  </button>
                                  <button
                                    type="button"
                                    title="Change Password"
                                    className="btn-custom-button btn_change_password"
                                    onClick={() =>
                                      handleModalOpen("Change Password", client)
                                    }
                                  >
                                    P
                                  </button>
                                  <button
                                    type="button"
                                    title="Change Status"
                                    className="btn-custom-button btn_change_status"
                                    onClick={() =>
                                      handleModalOpen("Status", client)
                                    }
                                  >
                                    S
                                  </button>
                                  <button
                                    type="button"
                                    title="Global Settings"
                                    className="btn-custom-button btn_change_status"
                                    onClick={() =>
                                      handleModalOpen("Global Setting", client)
                                    }
                                  >
                                    GS
                                  </button>
                                  <button
                                    type="button"
                                    title="Activity Log"
                                    className="btn-custom-button btn_change_status"
                                    onClick={() =>
                                      navigate(
                                        `/admin/activity-log/${client.username}`
                                      )
                                    }
                                  >
                                    A
                                  </button>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                          );
                        })}
                    </tbody>
                  </table>
                  {/*  <div
                    className="dataTables_info"
                    id="clientListTable_info"
                    role="status"
                    aria-live="polite"
                  >
                    Showing {clientData.length} to {clientData.length} of{" "}
                    {clientData.length} entries
                  </div> */}
                </div>
              </div>
              <div
                className="client-list-pagination"
                id="clientListTable_paginate"
              >
                <a
                  className={`previous button btn btn-diamond${currentPage === 0 ? " disabled" : ""}`}
                  style={{ background: "linear-gradient(to bottom, #f0c454, #d4a017)", color: "#1a1a2e", fontWeight: "600", border: "none" }}
                  aria-controls="clientListTable"
                  tabIndex={currentPage === 0 ? -1 : 0}
                  id="clientListTable_previous"
                  onClick={() => currentPage > 0 && prevPage()}
                  aria-disabled={currentPage === 0}
                >
                  Previous
                </a>
                <span className="page-info">
                  Page {currentPage + 1} of {totalPages || 1}
                </span>
                <a
                  className={`next button btn btn-diamond${currentPage >= totalPages - 1 ? " disabled" : ""}`}
                  style={{ background: "linear-gradient(to bottom, #f0c454, #d4a017)", color: "#1a1a2e", fontWeight: "600", border: "none" }}
                  aria-controls="clientListTable"
                  tabIndex={currentPage >= totalPages - 1 ? -1 : 0}
                  id="clientListTable_next"
                  onClick={() => currentPage < totalPages - 1 && nextPage()}
                  aria-disabled={currentPage >= totalPages - 1}
                >
                  Next
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
